module.exports = __webpack_public_path__ + "img/r-223.15959417.jpg";